export class SerializationHelper {
    static toInstance<T extends Serializable>(obj: T, json: string): T {
        var jsonObj = JSON.parse(json);
        return SerializationHelper.toInstanceFromJsonObj(obj, jsonObj);
    }
    
    static toInstanceFromJsonObj<T extends Serializable>(obj: T, jsonObj: any): T {
        if (jsonObj === undefined || jsonObj === null) {
            return null;
        }
        
        obj.fromJSON(jsonObj);

        return obj;
    }

    static toArrayInstanceFromJsonObjArray<T extends Serializable>(constructor: () => T, jsonObjArray: any[]): T[] {
        if (jsonObjArray === undefined || jsonObjArray === null) {
            return null;
        }

        return jsonObjArray.map((item) => {
            return SerializationHelper.toInstanceFromJsonObj(constructor(), item);
        });
    }

    static toArrayInstanceFromJsonStringArray<T extends Serializable>(constructor: () => T, jsonStringArray: string): T[] {
        return SerializationHelper.toArrayInstanceFromJsonObjArray(constructor, JSON.parse(jsonStringArray));
    }
    
    static copyProperties<T>(obj: T, jsonObj: any, propertyNames?: string[]): T {
        if (propertyNames) {
            propertyNames.forEach((propName) => (obj[propName as keyof typeof obj] = jsonObj[propName]));
        } else {
            for (const propName in jsonObj) {
                obj[propName as keyof typeof obj] = jsonObj[propName];
            }
        }
        return obj;
    }
    
    static copyNonExcludedProperties<T>(obj: T, jsonObj: any, propertyNamesToExclude: string[]): T {
        const copiedProps = [];
        for (const propName in jsonObj) {
            if (propertyNamesToExclude.indexOf(propName) < 0) {
                obj[propName as keyof typeof obj] = jsonObj[propName];
                copiedProps.push(propName);
            }
        }
        for (const propName in obj) {
            if (propertyNamesToExclude.indexOf(propName) < 0 && copiedProps.indexOf(propName) < 0) {
                obj[propName as keyof typeof obj] = jsonObj[propName];
            }
        }
        return obj;
    }
    
    static parseStringToBoolean(stringBoolean: string): boolean {
        return stringBoolean === "true" ? true : false;
    }
}

export interface Serializable {
    fromJSON(rawObject: any): void;
}
